<template>
  <v-app-bar app :clipped-left="clipped" dense fixed :color="appBarColor">
    <v-icon @click="expandMenu($event)" :color="listColor">mdi-menu</v-icon>
    <v-spacer></v-spacer>
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="red darken-1" icon dark v-bind="attrs" v-on="on">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          link
          @click="link(item.url)"
        >
          <v-list-item-title
            ><v-icon>{{ item.icon }}</v-icon> {{ item.title }}</v-list-item-title
          >
        </v-list-item>
        <template>
          <v-btn dark color="red darken-1" @click="logout">
            <v-icon>mdi-logout</v-icon> Logout
          </v-btn>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppTopBar",
  data: () => ({
    drawer: true,
    clipped: false,
    group: null,
    show: true,
    listColor: "#a7040f",
    appBarColor: "#ECEFF1",
    items: [
      { icon: "mdi-account-edit", url: "/admin/profile", title: "Profile" },
      { icon: "mdi-account-edit", url: "/password", title: "Password" },
      //{ icon: "mdi-logout", url: "", title: "Logout" },
    ],
  }),

  methods: {
    link(moveto) {
      //console.log(moveto);
      this.$router.push(moveto);
    },
    expandMenu(e) {
      console.log("expandMenu Topbar");
      console.log(e);
      this.show = !this.show;
      this.$emit("expandMenu", this.show);
    },
    logout() {
      console.log(this.$store);
      this.$cookies.set("isAuth", false);
      this.$store.dispatch("logout");
      //this.$router.push("/login");
      window.location.href = "/";
    },
  },

  watch: {
    group() {
      // this.drawer = false
    },
  },
};
</script>
